import React from 'react';
import PdfPage from './PdfPage';

function PdfLocation({ data, officeName, dateLabel }) {
  return (
    <PdfPage officeName={officeName} pageLabel="Property Report" dateLabel={dateLabel} className="p05">
      <div className="p05__band"><span className="p05__chapter">위치 안내</span></div>
      <div className="p05__body">
        <figure className="p05__fig">
          <div className="p05__caption"><span className="p05__cap-tag">01</span><span className="p05__cap-title">위치</span></div>
          <div className="p05__slot">
            {data.mapImage && <img src={data.mapImage} crossOrigin="anonymous" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
          </div>
        </figure>
        <figure className="p05__fig">
          <div className="p05__caption"><span className="p05__cap-tag">02</span><span className="p05__cap-title">지적도</span></div>
          <div className="p05__slot">
            {data.cadastralImage && <img src={data.cadastralImage} crossOrigin="anonymous" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
          </div>
        </figure>
      </div>
    </PdfPage>
  );
}

export default PdfLocation;
